import { render, staticRenderFns } from "./RenewalDetail.vue?vue&type=template&id=230ec2b8&"
import script from "./RenewalDetail.vue?vue&type=script&lang=js&"
export * from "./RenewalDetail.vue?vue&type=script&lang=js&"
import style0 from "./RenewalDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports